import React from 'react';

const MyFilesPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/files',
			exact: true,
			component: React.lazy(() => import('./MyFilesPage')),
		},
	],
};

export default MyFilesPageConfig;
